import { useModal, useSearchParams } from '@starsoft/common/hooks';
import { useSystemConfiguration } from '../theme/useSystemConfiguration';
import { ModalsKey } from '@/enums/modalsKey';
import { useMemo } from 'react';
import { RedirectType } from '@starsoft/common/models/origin/redirect/type';
import useTranslation from 'next-translate/useTranslation';
import { platformAssets } from '@/utils/assets';
import { parseToBigInt } from '@starsoft/common/utils/parsers';

export function useCountryRedirect() {
  const { t } = useTranslation('common');
  const search: URLSearchParams = useSearchParams();
  const { setting } = useSystemConfiguration();
  const modalCallbacks = useModal(ModalsKey.Redirect);

  const redirectUrl = search.get('redirectUrl');
  const redirectId = search.get('redirectId');

  const redirectById = setting.origin.redirects.find(
    redirect => redirect.id == (parseToBigInt(redirectId) as bigint),
  );

  const title = useMemo(() => {
    switch (redirectById?.redirect?.type) {
      case RedirectType.Restricted:
        return t('country_redirect_exclusive_title', {
          app_provider: platformAssets.app,
          country: redirectById?.country?.name,
        });
      case RedirectType.Inclusive:
        return t('country_redirect_inclusive_title', {
          app_provider: platformAssets.app,
          country: redirectById?.country?.name,
        });
      default:
        return t('country_redirect_inclusive_title', {
          app_provider: platformAssets.app,
          country: redirectById?.country?.name,
        });
    }
  }, [redirectById, t]);

  const description = useMemo(() => {
    switch (redirectById?.redirect?.type) {
      case RedirectType.Restricted:
        return t('country_redirect_exclusive_description', {
          app_provider: platformAssets.app,
          country: redirectById?.country?.name,
        });
      case RedirectType.Inclusive:
        return t('country_redirect_inclusive_description', {
          app_provider: platformAssets.app,
          country: redirectById?.country?.name,
        });
      default:
        return t('country_redirect_inclusive_description', {
          app_provider: platformAssets.app,
          country: redirectById?.country?.name,
        });
    }
  }, [redirectById, t]);

  return {
    redirectById,
    redirectUrl,
    modalCallbacks,
    title,
    description,
  };
}
